// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type OptionCustomDateFragment = { __typename?: 'NotificationOptionCustomDates' } & Pick<
  Types.NotificationOptionCustomDates,
  'enabled' | 'notifiedUsers' | 'notifiedDates'
>;

export type OptionStaticDateFragment = { __typename?: 'NotificationOptionStaticDates' } & Pick<
  Types.NotificationOptionStaticDates,
  'enabled' | 'notifiedUsers'
>;

export type NotificationSettingQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;

export type NotificationSettingQuery = { __typename?: 'Query' } & {
  notificationSetting: Types.Maybe<
    { __typename?: 'NotificationSetting' } & Pick<Types.NotificationSetting, 'companyId'> & {
        company: { __typename?: 'Company' } & Pick<Types.Company, 'countryId'>;
        contractEndDate: { __typename?: 'NotificationOptionCustomDates' } & OptionCustomDateFragment;
        employmentEndDate: { __typename?: 'NotificationOptionCustomDates' } & OptionCustomDateFragment;
        idExpiryDate: { __typename?: 'NotificationOptionCustomDates' } & OptionCustomDateFragment;
        lastWorkingDate: { __typename?: 'NotificationOptionCustomDates' } & OptionCustomDateFragment;
        passportExpiryDate: { __typename?: 'NotificationOptionCustomDates' } & OptionCustomDateFragment;
        probationReviewDeadlineForEach: { __typename?: 'NotificationOptionCustomDates' } & OptionCustomDateFragment;
        probationReviewResult: { __typename?: 'NotificationOptionStaticDates' } & OptionStaticDateFragment;
        probationReviewScheduledEndDate: { __typename?: 'NotificationOptionStaticDates' } & OptionStaticDateFragment;
        returnFromExtendedLeave: { __typename?: 'NotificationOptionCustomDates' } & OptionCustomDateFragment;
        sixMonthServiceCompletion: Types.Maybe<
          { __typename?: 'NotificationOptionStaticDates' } & OptionStaticDateFragment
        >;
        visaExpiryDate: { __typename?: 'NotificationOptionCustomDates' } & OptionCustomDateFragment;
        workPermitExpiryDate: { __typename?: 'NotificationOptionCustomDates' } & OptionCustomDateFragment;
      }
  >;
};

export const OptionCustomDateFragmentDoc = /*#__PURE__*/ gql`
    fragment optionCustomDate on NotificationOptionCustomDates {
  enabled
  notifiedUsers
  notifiedDates
}
    `;
export const OptionStaticDateFragmentDoc = /*#__PURE__*/ gql`
    fragment optionStaticDate on NotificationOptionStaticDates {
  enabled
  notifiedUsers
}
    `;
export const NotificationSettingDocument = /*#__PURE__*/ gql`
    query NotificationSetting($companyId: ID!) {
  notificationSetting(companyId: $companyId) {
    companyId
    company {
      countryId
    }
    contractEndDate {
      ...optionCustomDate
    }
    employmentEndDate {
      ...optionCustomDate
    }
    idExpiryDate {
      ...optionCustomDate
    }
    lastWorkingDate {
      ...optionCustomDate
    }
    passportExpiryDate {
      ...optionCustomDate
    }
    probationReviewDeadlineForEach {
      ...optionCustomDate
    }
    probationReviewResult {
      ...optionStaticDate
    }
    probationReviewScheduledEndDate {
      ...optionStaticDate
    }
    returnFromExtendedLeave {
      ...optionCustomDate
    }
    sixMonthServiceCompletion {
      ...optionStaticDate
    }
    visaExpiryDate {
      ...optionCustomDate
    }
    workPermitExpiryDate {
      ...optionCustomDate
    }
  }
}
    ${OptionCustomDateFragmentDoc}
${OptionStaticDateFragmentDoc}`;

/**
 * __useNotificationSettingQuery__
 *
 * To run a query within a React component, call `useNotificationSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationSettingQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useNotificationSettingQuery(
  baseOptions: Apollo.QueryHookOptions<NotificationSettingQuery, NotificationSettingQueryVariables> &
    ({ variables: NotificationSettingQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NotificationSettingQuery, NotificationSettingQueryVariables>(
    NotificationSettingDocument,
    options,
  );
}
export function useNotificationSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NotificationSettingQuery, NotificationSettingQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NotificationSettingQuery, NotificationSettingQueryVariables>(
    NotificationSettingDocument,
    options,
  );
}
// @ts-expect-error
export function useNotificationSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationSettingQuery, NotificationSettingQueryVariables>,
): Apollo.UseSuspenseQueryResult<NotificationSettingQuery, NotificationSettingQueryVariables>;
export function useNotificationSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<NotificationSettingQuery, NotificationSettingQueryVariables>,
): Apollo.UseSuspenseQueryResult<NotificationSettingQuery | undefined, NotificationSettingQueryVariables>;
export function useNotificationSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<NotificationSettingQuery, NotificationSettingQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<NotificationSettingQuery, NotificationSettingQueryVariables>(
    NotificationSettingDocument,
    options,
  );
}
export type NotificationSettingQueryHookResult = ReturnType<typeof useNotificationSettingQuery>;
export type NotificationSettingLazyQueryHookResult = ReturnType<typeof useNotificationSettingLazyQuery>;
export type NotificationSettingSuspenseQueryHookResult = ReturnType<typeof useNotificationSettingSuspenseQuery>;
